import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
import { FloatingElements } from './FloatingElements';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.45
    }
  }
};
export function OldSolutions() {
  return <section className="bg-dark py-20 md:py-32 px-5 relative overflow-hidden" data-id="element-65">
      <FloatingElements count={6} variant="danger" data-id="element-66" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-68">
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white leading-tight mb-12 text-center" data-id="element-69">
            Lo que has intentado{' '}
            <span className="text-urgency" data-id="element-70">NO FUNCIONA</span>
          </h2>
        </motion.div>

        <motion.div className="space-y-3" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-71">
          <motion.div variants={itemVariants} className="bg-dark-card rounded-xl p-5 flex items-start gap-4 border border-urgency/15" data-id="element-72">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-urgency/15 flex items-center justify-center mt-0.5" data-id="element-73">
              <XIcon className="w-4 h-4 text-urgency" data-id="element-74" />
            </div>
            <p className="font-sans text-white leading-relaxed" data-id="element-75">
              <strong data-id="element-76">Decir NO sin estructura</strong>
              <span className="text-white/40" data-id="element-77"> → pelea o culpa.</span>
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-dark-card rounded-xl p-5 flex items-start gap-4 border border-urgency/15" data-id="element-78">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-urgency/15 flex items-center justify-center mt-0.5" data-id="element-79">
              <XIcon className="w-4 h-4 text-urgency" data-id="element-80" />
            </div>
            <p className="font-sans text-white leading-relaxed" data-id="element-81">
              <strong data-id="element-82">Comprar para que se calme</strong>
              <span className="text-white/40" data-id="element-83">
                {' '}
                → enseña que insistir funciona.
              </span>
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-dark-card rounded-xl p-5 flex items-start gap-4 border border-urgency/15" data-id="element-84">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-urgency/15 flex items-center justify-center mt-0.5" data-id="element-85">
              <XIcon className="w-4 h-4 text-urgency" data-id="element-86" />
            </div>
            <p className="font-sans text-white leading-relaxed" data-id="element-87">
              <strong data-id="element-88">Ahorro cuando sobra</strong>
              <span className="text-white/40" data-id="element-89"> → nunca sobra.</span>
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-dark-card rounded-xl p-5 flex items-start gap-4 border border-urgency/15" data-id="element-90">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-urgency/15 flex items-center justify-center mt-0.5" data-id="element-91">
              <XIcon className="w-4 h-4 text-urgency" data-id="element-92" />
            </div>
            <p className="font-sans text-white leading-relaxed" data-id="element-93">
              <strong data-id="element-94">Apps sin reglas de casa</strong>
              <span className="text-white/40" data-id="element-95"> → digitalizan el caos.</span>
            </p>
          </motion.div>
        </motion.div>

        {/* Urgency line */}
        <motion.p className="text-center mt-10 font-display text-xl font-bold text-urgency urgency-pulse" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} viewport={{
        once: true
      }} data-id="element-96">
          <AlertTriangleIcon className="w-5 h-5 inline mr-2 mb-0.5" data-id="element-97" />
          ¿Cuánto más vas a esperar?
        </motion.p>
      </div>
    </section>;
}